module.exports = __webpack_public_path__ + "static/img/cop_sch_logo28.0327f81c.png";